(function ($, Drupal) {

  "use strict";

  /**
   * Desktop mega menu.
   */
  Drupal.behaviors.vistraMegaMenu = {
    attach: function (context, settings) {

      var _header = $('.vistra-desktop-mega-menu', context);
      var _pageContent = $('.vistra-page-content', context);
      var _searchBox = _header.next();

      // Look for attribute changes on the body element. This is simply to
      // get the correct top padding once the administration toolbar is present.
      if ($('body', context).hasClass('toolbar-fixed')) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              _header.css('top', mutation.target.style.paddingTop);
              var pageContentPosition = _header.outerHeight();
              // Change the position of search box (only on desktop) and main content. For the main content
              // we need to allow for the extra padding added on the container fluid container
              if (window.innerWidth > 1200) {
                pageContentPosition = _header.outerHeight() - 22;
                var searchTopPosition = parseInt(mutation.target.style.paddingTop) + _header.outerHeight();
                _searchBox.css('top', searchTopPosition + 'px');
              }
              _pageContent.css('padding-top', pageContentPosition + 'px');
            }
          });
        });

        observer.observe(document.querySelector('body'), {
          attributes: true
        });
      }

      // We need to set the min-height on the mega menu as there might be
      // cases where the wrapper would be smaller than the opening 4th level.
      // $(once('mega-menu-height', '.vistra-desktop-mega-menu .block-colossal-menu > ul > li', context)).each(function () {
      //   $(this).on('mouseover', function () {
      //     // Checker to only run this on non-checked items.
      //     if ($(this).hasClass('sized')) {
      //       return false;
      //     }

      //     var minHeight = 0;
      //     var _link = $(this).find('.paragraph--type-mega-menu-card', context);

      //     // Loop over all the level 4 wrappers to determine which one is the
      //     // biggest.
      //     _link.find('.mm-level-4-wrapper', context).each(function () {
      //       var menuHeight = $(this).height();
      //       if (menuHeight > minHeight) {
      //         minHeight = menuHeight;
      //       }
      //     });


      //     // Set the style and class.
      //     _link.css('min-height', minHeight + 15);
      //     $(this).addClass('sized');
      //   });
      // });

      // Open and close mobile menu.
      // $(once('mega-menu-mobile', '.vistra-desktop-mega-menu .block-colossal-menu > ul > li > .mobile-expand', context)).on('click', function () {
      //   $(this).parent().toggleClass('opened').find('.colossal-menu-link', context).toggle();
      // });

    }
  };

  /**
   * Hero cards - Red boxes.
   */
  var opened = false;
  Drupal.behaviors.vistraHeroCard = {
    attach: function (context, settings) {
      var _hero = $('.paragraph--type-hero', context);
      var _link = $('.paragraph--type-hero').find('.cta-description', context);
      const slider = $(once('slider','.paragraph-hero-wrapper .field--name-field-slides', context));
      if (slider.length) {
        // Set default slick options.
        var slickConfig = {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 8000,
          autoplay: true,
        }
        // Check if there is a slide anchor set and add additional slick options.
        var anchorSlide = Drupal.behaviors.vistraHeroCard.getSlide();
        if (anchorSlide) {
          var SlideCnt = slider.children('.field__item', context).length;
          // Check if anchorSlide is available.
          if (anchorSlide <= SlideCnt) {
            slickConfig.initialSlide = anchorSlide - 1;
            slickConfig.autoplay = false;
          }
        }

        // Catch click on slide and if it is a "slide-link"
        // load page with slide url link.
        slider.find('.slide-link').each(function () {
          $(this).on('click', function () {
            var url = $(this).data('url');
            if(url){
              document.location.assign(url);
            }
          });
        });

        slider.on("afterChange init", function (){

          if ($('.slick-active .paragraph--type-hero-slide').hasClass('dark-theme')) {
            $('.hero-timezone').addClass('dark-theme');
          } else {
            $('.hero-timezone').removeClass('dark-theme');
          }
          if ($('.slick-active .paragraph--type-hero-slide').hasClass('light-theme')) {
            $('.hero-timezone').addClass('light-theme');
          } else {
            $('.hero-timezone').removeClass('light-theme');
          }
        });
        // Initialize slick carousel.
        slider.slick(slickConfig);
      }

      /*
      * Calculate hero card height.
      */
      var windowWidth = $(window).outerWidth();

      if (_hero.length > 0) {
        // Check if red boxes are shown.
        if (_hero.find('.field--name-field-cards').length == 0) {
          _hero.addClass('red-boxes-hidden')
        }

        // Loop over all cta-description wrappers to determine which one is the
        // biggest.
        var minHeight = 0;
        if (opened === false) {
          const link = once('_linked', _link);
          $(link).each(function () {
            $(this).show();

            // Add classes.
            $(this).parents('.field__item').addClass('opened');
            $(this).parents('.field--name-field-cards').addClass('opened');
            $(this).parents('.cta-wrapper').find('.cta-box').addClass('opened');

            // Get actual height.
            var menuHeight = $(this).find('.field--name-field-body').outerHeight(true);

            // Remove classes.
            $(this).parents('.field__item').removeClass('opened');
            $(this).parents('.field--name-field-cards').removeClass('opened');
            $(this).parents('.cta-wrapper').find('.cta-box').removeClass('opened');
            $(this).hide();
            if (menuHeight > minHeight) {
              minHeight = menuHeight;
            }
          });

          // Set the style and class.
          _link.css('min-height', minHeight);

          // Get height of red boxes wrapper.
          var cards = $('.paragraph--type-hero .field--name-field-cards', context).outerHeight();

          // Hero wrapper element.
          var slideWrapper = $(".slide-wrapper", context);

          // Get slideWrapper outerHeight.
          var slideHeight = slideWrapper.outerHeight();

          // Get header height
          var headerHeight = $('.global-header.vistra-desktop-mega-menu', context).outerHeight();
          opened = true;
        }
      }

      // On click, open description.
      $('.cta-box', context).on('click', function (e) {

        // Get height of red box for calculation.
        var _boxHeight = 160;
        if (windowWidth < 992) {
          _boxHeight = $(this).outerHeight();
        }

        if (windowWidth > 992) {
          // Set negative margin and height for red boxes wrapper.
          if ($(this).closest('.field__item').hasClass('opened')) {
            $(this).closest('.field--name-field-cards').removeClass('opened').find('.opened').css('margin-top', '0');
            $(this).closest('.field--name-field-cards').css('height', 'auto');
          }
          else {
            $(this).closest('.field--name-field-cards').removeClass('opened').find('.opened').css('margin-top', '0');
            $(this).closest('.field__item').css('margin-top', _boxHeight - minHeight);
            $(this).closest('.field--name-field-cards').css('height', _boxHeight + 85);
          }
        }

        // If you double click on the box that is opened.
        if ($(this).closest('.field__item').hasClass('opened')) {
          $(this).closest('.field--name-field-cards').removeClass('opened').find('.opened').removeClass('opened');
        }
        else {
          $(this).closest('.field--name-field-cards').removeClass('opened').find('.opened').removeClass('opened');
          $(this).closest('.field--name-field-cards').addClass('opened');
          $(this).closest('.field__item').addClass('opened');
        }
      });
    },
    getSlide: function () {
      var anchor = Drupal.behaviors.vistraHeroCard.getAnchor();
      if (anchor != null) {
        return anchor.substr(5);
      }
      return null;
    },
    getAnchor: function () {
      return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
    }
  };

  /**
   * Hero card scroll down.
   */
  Drupal.behaviors.vistraHeroScroll = {
    attach: function (context, settings) {
      $('.arrow-down', context).on('click', function (e) {
        e.preventDefault();
        var position = $(this).closest('.paragraph').next().offset().top;
        $("body, html").animate({
            scrollTop: position
          },
          1500
        );
      })
    }
  };

  /**
   * Hero card scroll down.
   */
  Drupal.behaviors.countUpNumber = {
    attach: function (context, settings) {
      if ($.fn.counterUp) {
        $(once("countUpNumber",'.counter', context)).counterUp({
          delay: 5,
          time: 300,
        });
      }
    }
  };

  /**
   * Hero card scroll down.
   */
  Drupal.behaviors.visibleFadeIn = {
    attach: function (context, settings) {

      var win = $(window);
      var allMods = $(".visible-fade-in");

      // Already visible modules
      allMods.each(function (i, el) {
        var el = $(el);
        if (el.visible(true)) {
          el.addClass("already-visible");
        }
      });

      win.scroll(function (event) {
        allMods.each(function (i, el) {
          var el = $(el);
          if (el.visible(true)) {
            el.addClass("come-in");
          }
        });
      });
    }
  };

  /**
   * Logic around Header card.
   */
  Drupal.behaviors.headerCard = {
    attach: function (context, settings) {
      // If media modal was opened, add class to body.
      if ($(context).is('.media--view-mode-modal')) {
        $('body').addClass('video-modal-opened');
      }
      // Remove added class when dialog closes.
      $('#drupal-modal').on('dialogclose', function (event) {
        $('body').removeClass('video-modal-opened');
      });
    }
  }

  /**
   * Slick carousel.
   */
  Drupal.behaviors.galleryCarousel = {
    attach: function (context, settings) {
      if ($.fn.slick) {
        $(once("galleryCarousel", '.view-gallery.view-display-id-gallery_block', context)).each(function () {
          var slides = $('> .view-content', $(this));
          if (slides.length) {
            slides.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
              asNavFor: $('.attachment .view-gallery > .view-content', $(this)),
              adaptiveHeight: true
            });
          }

          $(once('slides', slides)).on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            var CurrentSlideDom = $(slick.$slides.get(currentSlide));

            // Stop video on change.
            if (CurrentSlideDom.find('video').length > 0) {
              CurrentSlideDom.find('video').get(0).pause();
            }

            // Stop iframe video on change.
            if (CurrentSlideDom.find('.media-oembed-content').length > 0) {
              var iframe = CurrentSlideDom.find('.media-oembed-content');

              iframe.each(function (index) {
                $(this).attr('src', $(this).attr('src'));
                return false;
              });
            }
          });

          var thumbnails = $('.attachment .view-gallery > .view-content', $(this));
          if (thumbnails.length) {
            thumbnails.slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              asNavFor: $(this).find('> .view-content'),
              focusOnSelect: true,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                  }
                }
              ]
            });
          }
        })
      }
    }
  };

})(jQuery, Drupal);
